module.exports = __webpack_public_path__ + "img/company_introduce.12bcbc52.png";